import type { FilterPanelRowProps } from "./types-filter-row";
import { useFilterPanelRow } from "./use-filter-row";
import { FilterPanelRowView } from "./view-filter-row";

/** Uma linha: campo com busca → valor conforme o tipo → lixeira. */
export function FilterPanelRow(props: FilterPanelRowProps) {
  const viewModel = useFilterPanelRow(props);

  return <FilterPanelRowView {...viewModel} />;
}
FilterPanelRow.displayName = "FilterPanel.Row";
